import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {Box, useTheme} from "@mui/material";
import React from "react";


export default function BudgetStatus({ budgets, transactions }) {
   const theme = useTheme();
   const formatCurrency = (amount) => `$${amount.toFixed(2)}`;

   const totalBudget = budgets.reduce((sum, budget) => sum + budget.categoryBudget, 0);
   const totalSpend = transactions.reduce((sum, transaction) => sum + transaction.amount, 0);
   const difference = totalBudget - totalSpend;

   const remainingLabel = difference >= 0 ? "Remaining" : "Overage";
   const remainingValue = difference >= 0 ? difference : -difference;
   const remainingColor = difference >= 0 ? theme.palette.secondary.main : theme.palette.overage.main;

   return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
         <Paper
            elevation={3}
            sx={{
               flexGrow: 1,
               p: 2,
               display: 'flex',
               flexDirection: 'column',
               gap: 1.5,
               justifyContent: 'center'
            }}
         >
            <DottedLineItem
               label="Budget"
               value={formatCurrency(totalBudget)}
               labelVariant="h6"
               valueVariant="h6"
            />
            <DottedLineItem
               label="Total Spend"
               value={formatCurrency(totalSpend)}
            />
            <DottedLineItem
               label={remainingLabel}
               value={formatCurrency(remainingValue)}
               labelVariant="h6"
               valueVariant="h6"
               valueColor={remainingColor}
            />
         </Paper>
      </Box>
   );
}



function DottedLineItem({ label, value, labelVariant = "body1", valueVariant = "body1", sx = {}, valueColor }) {
   return (
      <Box
         sx={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr auto',
            alignItems: 'baseline',
            gap: 1,
            width: '100%',
            ...sx
         }}
      >
         <Typography variant={labelVariant} sx={{ whiteSpace: 'nowrap' }}>
            {label}
         </Typography>
         <Box
            sx={{
               borderBottom: '2px dotted #bdbdbd',
               marginBottom: '5px',
            }}
         />
         <Typography variant={valueVariant} sx={{ whiteSpace: 'nowrap', fontWeight: 'medium', color: valueColor }}>
            {value}
         </Typography>
      </Box>
   );
}